import { render, staticRenderFns } from "./SysCompradorAutocomplete.vue?vue&type=template&id=05c20516&scoped=true"
import script from "./SysCompradorAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysCompradorAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SysCompradorAutocomplete.vue?vue&type=style&index=0&id=05c20516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c20516",
  null
  
)

export default component.exports